import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { EquipmentComponent } from './components/equipment.component';
import { EquipmentDetailsComponent } from './components/equipment-details/equipment-details.component';
import { EquipmentRoutingModule } from './equipment-routing.module';
import { AssetModule } from '../../assets/asset/asset.module';

@NgModule({
  declarations: [EquipmentComponent, EquipmentDetailsComponent],
  imports: [
    EquipmentRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    AssetModule
  ],
})
export class EquipmentModule {}

export function loadEquipmentModuleAsChild() {
  return Promise.resolve(EquipmentModule);
}
